import React from "react"
import { ReactComponent as CameraIcon } from "../../Assets/Icons/camera.svg"
import { ReactComponent as OnlineIcon } from "../../Assets/Icons/green-check.svg"
// import { ReactComponent as AlertIcon } from "../../Assets/Icons/hex.svg"
import { ReactComponent as OfflineIcon } from "../../Assets/Icons/offline.svg"
import { STATUS_TYPES } from "./common"
import { DateFormat, TimeFormat } from "../../Helper/dateFormats"

export const DESKTOP_LAYOUT_OPTIONS = ["2x2", "2x3", "3x3"]

export const GRID_COL_MAP = {
  "1x1": "grid-cols-1",
  "2x2": "grid-cols-1 sm:grid-cols-2",
  "2x3": "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
  "3x3": "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
}

export const GRID_HEIGHT_MAP = {
  "1x1": "h-[320px] sm:h-[480px]",
  "2x2": "h-[200px] sm:h-[320px]",
  "2x3": "h-[160px] sm:h-[240px]",
  "3x3": "h-[140px] sm:h-[180px]",
}

export const getGridCols = (layout) => {
  return GRID_COL_MAP[layout] || "grid-cols-1"
}

export const getHeightClass = (layout) => {
  return GRID_HEIGHT_MAP[layout] || "h-[180px]"
}

export const CAMERA_CATEGORIES = [
  { label: "All Cameras", value: "1" },
  { label: "Favorites", value: "2" },
]

// User-facing sort choices (values stored in the camera store / used by the Select).
export const SORT_BY = {
  NEW_TO_OLD: "new_to_old",
  OLD_TO_NEW: "old_to_new",
}

// API `sortOrder` param values.
export const SORT_ORDER = {
  ASC: "ASC",
  DESC: "DESC",
}

// Options rendered in the "Sort By" dropdowns.
export const SORT_OPTIONS = [
  { label: "New to old", value: SORT_BY.NEW_TO_OLD },
  { label: "Old to new", value: SORT_BY.OLD_TO_NEW },
]

export const PLAYER_TYPE = {
  LIVE: "live",
  PLAYBACK: "playback",
}

export const TIMELINE_TYPES = {
  PLAYHEAD: "playhead",
}

// Maps the user-facing sort choice to the API's sortOrder param.
export const getSortOrder = (sortBy) =>
  sortBy === SORT_BY.NEW_TO_OLD ? SORT_ORDER.ASC : SORT_ORDER.DESC

export const buildStatistics = (cameras = [], total = 0) => [
  {
    icon: <CameraIcon className="w-5 h-5 mt-1 text-primary1-600" />,
    title: "Total Cameras",
    value: total,
    bg: "bg-primary1-50",
    border: "border-primary1-200",
    labelClass: "text-secondary-500",
    valueClass: "text-secondary-900",
  },
  {
    icon: <OnlineIcon className="w-5 h-5 mt-1 text-[var(--stat-online-icon)]" />,
    title: "Online Cameras",
    value: cameras.filter((c) => c.status === STATUS_TYPES.ONLINE)?.length ?? 0,
    bg: "bg-[var(--stat-online-bg)]",
    border: "border-[var(--stat-online-border)]",
    labelClass: "text-[var(--stat-online-label)]",
    valueClass: "text-[var(--stat-online-value)]",
  },
  {
    icon: <OfflineIcon className="w-5 h-5 mt-1 text-[var(--stat-offline-icon)]" />,
    title: "Offline Cameras",
    value:
      cameras.filter((c) => c.status === STATUS_TYPES.OFFLINE)?.length ?? 0,
    bg: "bg-[var(--stat-offline-bg)]",
    border: "border-[var(--stat-offline-border)]",
    labelClass: "text-[var(--stat-offline-label)]",
    valueClass: "text-[var(--stat-offline-value)]",
  },
]

export const HOUR_LABELS = [
  "12a",
  "1a",
  "2a",
  "3a",
  "4a",
  "5a",
  "6a",
  "7a",
  "8a",
  "9a",
  "10a",
  "11a",
  "12p",
  "1p",
]

export const parseTimeToMinutes = (timeStr) => {
  if (!timeStr) return 0
  const match = timeStr.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i)
  if (!match) return 0
  let hours = parseInt(match[1], 10)
  const minutes = parseInt(match[2], 10)
  const ampm = match[3].toUpperCase()
  if (ampm === "PM" && hours < 12) hours += 12
  if (ampm === "AM" && hours === 12) hours = 0
  return hours * 60 + minutes
}

export const TIMELINE_OPTIONS = {
  zoomMin: 15 * 60 * 1000, // 1 minutes
  zoomMax: 30 * 24 * 60 * 60 * 1000, // 30 days
  height: "90px",
  showCurrentTime: false,
  showMajorLabels: true,
  showMinorLabels: true,
  orientation: "bottom",
  editable: false,
  selectable: true,
  stack: false,
  format: {
    minorLabels: {
      millisecond: "",
      second: TimeFormat.TWELVE_HOUR_AM_PM_SEC_SINGLE,
      minute: TimeFormat.TWELVE_HOUR_AM_PM_SINGLE,
      hour: TimeFormat.TWELVE_HOUR_AM_PM_SINGLE,
      weekday: DateFormat.DAY_DATE_SINGLE,
      day: DateFormat.DATE_SINGLE,
      week: DateFormat.WEEK_SINGLE,
      month: DateFormat.MONTH_SHORT_CAPS,
      year: DateFormat.YEAR_CAPS,
    },
    majorLabels: {
      millisecond: "",
      second: DateFormat.DATE_MONTH_TIME_AM_PM,
      minute: DateFormat.DAY_DATE_MONTH,
      hour: DateFormat.DAY_DATE_MONTH,
      weekday: DateFormat.MONTH_YEAR_CAPS,
      day: DateFormat.MONTH_YEAR_CAPS,
      week: DateFormat.MONTH_YEAR_CAPS,
      month: DateFormat.YEAR_CAPS,
      year: "",
    },
  },
}
